import React, {useState} from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom"
import baseURL from "../Url/Url.jsx";

const SideBar = ({
    bulanParams,
    tahunParams,
    perusahaanParams,
    tahunSekarang,
}) => {
    const [bulann, setBulann] = useState("Bulan")
    const [tahun, setTahun] = useState("Tahun")
    const navigate = useNavigate();
    // Pilih Periode
    const pilihPeriode = async(e)=>{
        e.preventDefault()
        try {
            await axios.patch(`${baseURL}/pilihPeriodeBE`,{
                perusahaan: perusahaanParams,
                bulan: bulann,
                tahun: tahun,
            })
            navigate(`/menu-dashboard/${perusahaanParams}/${bulann}/${tahun}`, { replace: true })
            window.location.reload()
        } catch (error) {
            if(error.response){
                console.log(error.response.data.msg)
            }
        }
    }
    return (
        <div>
            <div className="modal fade" id="staticBackdropPilihPeriode" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn btn-logout mx-auto px-4 py-1" data-bs-dismiss="modal" aria-label="Tutup">Tutup</button>
                        </div>
                        <div className="modal-body">
                            <p className="text-center fw-bold">Silahkan Untuk Pilih Periode</p>
                            <form onSubmit={pilihPeriode}>
                                <div className="row px-4">
                                    <div className="col-12 col-md-6 mb-3">
                                        <select className="form-select form text-center" id="bulan" aria-label="bulan" value={bulann} onChange={(e)=>setBulann(e.target.value)} required>
                                            <option defaultValue={bulanParams}>Bulan</option>
                                            <option defaultValue="JANUARI">JANUARI</option>
                                            <option defaultValue="FEBRUARI">FEBRUARI</option>
                                            <option defaultValue="MARET">MARET</option>
                                            <option defaultValue="APRIL">APRIL</option>
                                            <option defaultValue="MEI">MEI</option>
                                            <option defaultValue="JUNI">JUNI</option>
                                            <option defaultValue="JULI">JULI</option>
                                            <option defaultValue="AGUSTUS">AGUSTUS</option>
                                            <option defaultValue="SEPTEMBER">SEPTEMBER</option>
                                            <option defaultValue="OKTOBER">OKTOBER</option>
                                            <option defaultValue="NOVEMBER">NOVEMBER</option>
                                            <option defaultValue="DESEMBER">DESEMBER</option>
                                        </select>
                                    </div>
                                    <input type="text" className="form-disable" value={perusahaanParams} readOnly/>
                                    <div className="col-12 col-md-6 mb-3">
                                        <select className="form-select form text-center" id="tahun" aria-label="tahun" value={tahun} onChange={(e)=>setTahun(e.target.value)} required>
                                            <option defaultValue={tahunSekarang}>Tahun</option>
                                            <option defaultValue="2020">2020</option>
                                            <option defaultValue="2021">2021</option>
                                            <option defaultValue="2022">2022</option>
                                            <option defaultValue="2023">2023</option>
                                            <option defaultValue="2024">2024</option>
                                            <option defaultValue="2025">2025</option>
                                            <option defaultValue="2026">2026</option>
                                            <option defaultValue="2027">2027</option>
                                            <option defaultValue="2028">2028</option>
                                            <option defaultValue="2029">2029</option>
                                            <option defaultValue="2030">2030</option>
                                            <option defaultValue="2031">2031</option>
                                            <option defaultValue="2032">2032</option>
                                            <option defaultValue="2033">2033</option>
                                            <option defaultValue="2034">2034</option>
                                            <option defaultValue="2035">2035</option>
                                            <option defaultValue="2036">2036</option>
                                            <option defaultValue="2037">2037</option>
                                            <option defaultValue="2038">2038</option>
                                            <option defaultValue="2039">2039</option>
                                            <option defaultValue="2040">2040</option>
                                            <option defaultValue="2041">2041</option>
                                            <option defaultValue="2042">2042</option>
                                            <option defaultValue="2043">2043</option>
                                            <option defaultValue="2044">2044</option>
                                            <option defaultValue="2045">2045</option>
                                            <option defaultValue="2046">2046</option>
                                            <option defaultValue="2047">2047</option>
                                            <option defaultValue="2048">2048</option>
                                            <option defaultValue="2049">2049</option>
                                            <option defaultValue="2050">2050</option>
                                        </select>
                                    </div>
                                    <input type="submit" className="btn btn-webew-login mb-4 mt-3" value="Oke"/>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* SIDEBAR*/}
            <nav className="navbar-expand-sm bg-navbar">
                <div className="dropdown ml-2"></div>
                <div className="collapse navbar-collapse" id="sidebar">
                    <ul className="navbar-nav sidebar" id="accordionSidebar">
                        <div className="navbar-brand d-flex align-items-center justify-content-center">
                            <img src="/img/newLogoMap.png" alt="logo map" className="d-block mx-auto" style={{width:"100px",marginTop:"5px"}}/>
                        </div>
                        <div className="sidebar-heading" style={{marginTop:"10px"}}>Menu Utama</div>
                        <li className="nav-item nav-itemm">
                            <button className="nav-link nav-linkk" data-bs-toggle="modal" data-bs-target="#staticBackdropPilihPeriode" style={{border:"none",backgroundColor:"white",marginTop:"-3px"}}><i className="bi bi-calendar4-week"style={{color:"rgb(0, 7, 198)"}}></i><span>Pilih Periode</span></button>
                        </li>
                        <li className="nav-item nav-itemm mb-1">
                            <Link className="nav-link nav-linkk" to={`/menu-dashboard/${perusahaanParams}/${bulanParams}/${tahunParams}`} style={{marginTop:"-5px"}}><i className="bi bi-columns-gap"style={{color:"rgb(106, 0, 198)"}}></i><span>Dashboard</span></Link>
                        </li>
                        <button className="sidebar-heading pb-2 col-12" style={{marginTop:"10px",border:"none",backgroundColor:"white",color:"rgb(108, 108, 108)"}} type="button" data-bs-toggle="collapse" data-bs-target="#perusahaan" aria-expanded="false" aria-controls="perusahaan">
                            DB Perusahaan <i className="bi bi-caret-down-fill" style={{color:"rgb(108, 108, 108)"}}></i>
                        </button>
                        <div className="collapse" id="perusahaan">
                            <div>
                                <li className="nav-item nav-itemm mb-3">
                                    <Link className="nav-link nav-linkk m-0 p-0" to={`/menu-perusahaan/${perusahaanParams}`}><i className="bi bi-buildings"style={{color:"rgb(198, 0, 0)"}}></i><span>Perusahaan</span></Link>
                                </li>
                            </div>
                        </div>
                        <button className="sidebar-heading pb-2 col-12" style={{marginTop:"10px",border:"none",backgroundColor:"white",color:"rgb(108, 108, 108)"}} type="button" data-bs-toggle="collapse" data-bs-target="#karyawan" aria-expanded="false" aria-controls="karyawan">
                            DB Karyawan <i className="bi bi-caret-down-fill" style={{color:"rgb(108, 108, 108)"}}></i>
                        </button>
                        <div className="collapse" id="karyawan">
                            <div>
                                <li className="nav-item nav-itemm mb-3">
                                    <Link className="nav-link nav-linkk m-0 p-0" to={`/menu-karyawan-tetap/${perusahaanParams}/${bulanParams}/${tahunParams}`}><i className="bi bi-people"style={{color:"rgb(0, 198, 195)"}}></i><span>Karyawan Tetap</span></Link>
                                    <Link className="nav-link nav-linkk m-0 p-0" to={`/menu-karyawan-tidak-tetap/${perusahaanParams}/${bulanParams}/${tahunParams}`}><i className="bi bi-people"style={{color:"rgb(0, 191, 198)"}}></i><span>Karyawan Tidak Tetap</span></Link>
                                </li>
                            </div>
                        </div>
                        <button className="sidebar-heading pb-2 col-12" style={{marginTop:"10px",border:"none",backgroundColor:"white",color:"rgb(108, 108, 108)"}} type="button" data-bs-toggle="collapse" data-bs-target="#perhitungan" aria-expanded="false" aria-controls="perhitungan">
                            DB Hitung PPH <i className="bi bi-caret-down-fill" style={{color:"rgb(108, 108, 108)"}}></i>
                        </button>
                        <div className="collapse" id="perhitungan">
                            <div>
                                <li className="nav-item nav-itemm mb-3">
                                    <Link className="nav-link nav-linkk m-0 p-0" to={`/menu-perhitungan-karyawan-tetap/${perusahaanParams}/${bulanParams}/${tahunParams}`}><i className="bi bi-calculator"style={{color:"rgb(198, 178, 0)"}}></i><span>Karyawan Tetap</span></Link>
                                    <Link className="nav-link nav-linkk m-0 p-0" to={`/menu-perhitungan-karyawan-tidak-tetap/${perusahaanParams}/${bulanParams}/${tahunParams}`}><i className="bi bi-calculator"style={{color:"rgb(198, 178, 0)"}}></i><span>Karyawan Tidak Tetap</span></Link>
                                </li>
                            </div>
                        </div>
                        <button className="sidebar-heading pb-2 col-12" style={{marginTop:"10px",border:"none",backgroundColor:"white",color:"rgb(108, 108, 108)"}} type="button" data-bs-toggle="collapse" data-bs-target="#cetak" aria-expanded="false" aria-controls="cetak">
                            Cetak Laporan <i className="bi bi-caret-down-fill" style={{color:"rgb(108, 108, 108)"}}></i>
                        </button>
                        <div className="collapse" id="cetak">
                            <div>
                                <li className="nav-item nav-itemm mb-3">
                                    <Link className="nav-link nav-linkk m-0 p-0" to={`/menu-laporan-gaji/${perusahaanParams}/${bulanParams}/${tahunParams}`}><i className="bi bi-printer"style={{color:"rgb(0, 198, 7)"}}></i><span>Laporan Gaji</span></Link>
                                    <Link className="nav-link nav-linkk m-0 p-0" to={`/menu-laporan-pph/${perusahaanParams}/${bulanParams}/${tahunParams}`}><i className="bi bi-printer"style={{color:"rgb(0, 198, 7)"}}></i><span>Laporan PPH</span></Link>
                                    <Link className="nav-link nav-linkk m-0 p-0" to={`/menu-laporan-slip/${perusahaanParams}/${bulanParams}/${tahunParams}`}><i className="bi bi-printer"style={{color:"rgb(0, 198, 7)"}}></i><span>Laporan Slip</span></Link>
                                    <Link className="nav-link nav-linkk m-0 p-0" to={`/menu-laporan-coretax/${perusahaanParams}/${bulanParams}/${tahunParams}`}><i className="bi bi-printer"style={{color:"rgb(0, 198, 7)"}}></i><span>Laporan CoreTax</span></Link>
                                </li>
                            </div>
                        </div>
                    </ul>
                </div>
            </nav>
        </div>
    )
}

export default SideBar